module.exports = __webpack_public_path__ + "img/mine.3ba17723.jpg";